var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmpulheta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.144,
    height: 211.451,
    viewBox: "0 0 168.144 211.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_576",
    "data-name": "Grupo 576",
    transform: "translate(0.803 2.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_460",
    "data-name": "Grupo 460",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2281",
    "data-name": "Caminho 2281",
    d: "M-303.538,670.976a43.5,43.5,0,0,1-30.827,10.819c-1.156-.056-2.317-.164-3.477-.315h0c-.29-.036-.575-.075-.868-.121a1.787,1.787,0,0,0-1.985,1.29l-.008.028c-.015.056-.025.109-.034.161a.228.228,0,0,0-.011.057c-.092-.065-.074-.055-.172-.118a19.953,19.953,0,0,0-4.366,2.686,19.8,19.8,0,0,0-2.355-4.549l-.2.009a.272.272,0,0,1-.032.061,1.347,1.347,0,0,0,.1-.266l.008-.028a1.8,1.8,0,0,0-.113-1.268,1.772,1.772,0,0,0-.926-.868q-.4-.165-.805-.344c-1.071-.468-2.122-.975-3.141-1.524a43.438,43.438,0,0,1-21.258-49.816l2.316-8.331a34.864,34.864,0,0,1,2.74-6.907l1.595,10.58a57.865,57.865,0,0,0,41.738,47.069A57.388,57.388,0,0,0-303.538,670.976Z",
    transform: "translate(429.181 -575.749)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2282",
    "data-name": "Caminho 2282",
    d: "M-352.866,886.188a34.706,34.706,0,0,1-33.248,8.309l-16.658-4.63a34.706,34.706,0,0,1-24.193-24.273c2.245-.262,11.483-1.389,20.9-3.381,11.253-2.379,18.586-5.046,22.2-8.092,1.524,4.473,6.43,10.542,14.842,18.386C-361.985,879.073-354.654,884.805-352.866,886.188Z",
    transform: "translate(455.774 -701.294)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_452",
    "data-name": "Grupo 452",
    transform: "translate(22.999 11.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2283",
    "data-name": "Caminho 2283",
    d: "M-382.39,650.272a1.767,1.767,0,0,0-.925-.868q-.4-.166-.805-.344,1.026,1.307,1.836,2.508l.008-.028A1.8,1.8,0,0,0-382.39,650.272Zm0,0a1.767,1.767,0,0,0-.925-.868q-.4-.166-.805-.344,1.026,1.307,1.836,2.508l.008-.028A1.8,1.8,0,0,0-382.39,650.272Zm8.081,5.3a1.118,1.118,0,0,0,.119.058l.018.005A1.381,1.381,0,0,1-374.308,655.577Zm-.971-1.566a.073.073,0,0,0,0,.03c0-.009,0-.015,0-.025A0,0,0,0,0-375.28,654.01Zm35.821-7.354h0a46.032,46.032,0,0,0,17.283-24.939l2.316-8.331a37.478,37.478,0,0,0,.6-17.682,37.707,37.707,0,0,0-17.178-24.461,37.452,37.452,0,0,0-9.593-4.168l-16.658-4.63a37.493,37.493,0,0,0-10.368-1.38,37.708,37.708,0,0,0-27.336,12.089,37.481,37.481,0,0,0-8.606,15.458l-2.315,8.331a46.339,46.339,0,0,0,21.559,52.518,46.33,46.33,0,0,0-45.565,33.858l-2.315,8.331A37.623,37.623,0,0,0-421.055,733.8a37.5,37.5,0,0,0,9.594,4.168l16.658,4.63a37.464,37.464,0,0,0,10.368,1.38,37.623,37.623,0,0,0,35.942-27.547l2.315-8.331a46.17,46.17,0,0,0,1.374-18,46.206,46.206,0,0,0-5.667-17.142,46.015,46.015,0,0,0-17.236-17.374A46.316,46.316,0,0,0-339.458,646.656Zm-29.416,5.99c-1.156-.056-2.317-.163-3.476-.315h0c-.291-.036-.575-.075-.868-.121a1.787,1.787,0,0,0-1.986,1.29l-.008.028c-.015.055-.025.108-.035.161a.251.251,0,0,0-.011.057c0,.014,0,.025-.005.039s0,.049,0,.069,0,.029-.005.039l0,.119a.073.073,0,0,0,0,.03c0,.05.008.1.009.148a1.042,1.042,0,0,0,.027.138,1.442,1.442,0,0,0,.039.166,1.625,1.625,0,0,0,.078.207.312.312,0,0,0,.018.045c.019.04.034.074.055.11l.007.012,0,.006.027.048a.8.8,0,0,0,.089.13.779.779,0,0,0,.1.123.141.141,0,0,0,.041.052.507.507,0,0,1,.059.056l.048.043a.709.709,0,0,0,.115.092c.008.007.013.008.021.015l.062.047a.149.149,0,0,1,.039.021.35.35,0,0,0,.06.037.441.441,0,0,0,.074.04,1.118,1.118,0,0,0,.119.058l.018.005c.225.093.454.186.676.288a43.02,43.02,0,0,1,20.506,18.448,43.1,43.1,0,0,1,4.024,32.943l-2.315,8.332a34.588,34.588,0,0,1-7.476,13.75q-.973,1.1-2.024,2.1a34.7,34.7,0,0,1-33.248,8.309l-16.658-4.63A34.7,34.7,0,0,1-434.88,710.9q-.385-1.4-.653-2.839a34.59,34.59,0,0,1,.692-15.635l2.315-8.331A43.427,43.427,0,0,1-385,652.725c.246.033.487.066.732.1a2.043,2.043,0,0,0,.305.019.553.553,0,0,0,.112-.009.267.267,0,0,0,.072-.005,1.281,1.281,0,0,0,.157-.026l.107-.026c.043-.013.082-.027.122-.041s.09-.035.136-.057a.943.943,0,0,0,.128-.065.965.965,0,0,0,.121-.076,1.041,1.041,0,0,0,.118-.083,1.681,1.681,0,0,0,.389-.427c.026-.043.054-.085.076-.129.011-.022.022-.044.035-.07s.021-.039.032-.061a1.661,1.661,0,0,0,.072-.2l.008-.028a1.8,1.8,0,0,0-.113-1.268,1.767,1.767,0,0,0-.925-.868q-.4-.166-.805-.344c-1.071-.468-2.122-.975-3.141-1.523a43.438,43.438,0,0,1-21.258-49.817l2.315-8.331a34.861,34.861,0,0,1,2.741-6.907,34.961,34.961,0,0,1,2.351-3.832,34.6,34.6,0,0,1,3.914-4.609,34.739,34.739,0,0,1,33.743-8.807l16.658,4.63a34.737,34.737,0,0,1,24.359,24.955,34.514,34.514,0,0,1-.2,17.793l-2.315,8.331a43.025,43.025,0,0,1-9.625,17.467,42.923,42.923,0,0,1-3.462,3.417A43.5,43.5,0,0,1-368.874,652.647Zm-13.516-2.375a1.767,1.767,0,0,0-.925-.868q-.4-.166-.805-.344,1.026,1.307,1.836,2.508l.008-.028A1.8,1.8,0,0,0-382.39,650.272Zm7.14,3.416a.251.251,0,0,0-.011.057c0,.014,0,.025-.005.039s0,.049,0,.069C-375.266,653.8-375.261,653.745-375.25,653.688Zm-.026.328a0,0,0,0,0,0-.006.073.073,0,0,0,0,.03C-375.275,654.031-375.279,654.025-375.276,654.016Zm.968,1.561a1.118,1.118,0,0,0,.119.058l.018.005A1.381,1.381,0,0,1-374.308,655.577Zm1.086-3.367a1.787,1.787,0,0,0-1.986,1.29l-.008.028c.874-.408,1.83-.8,2.861-1.2C-372.645,652.295-372.93,652.256-373.222,652.209Zm-9.168-1.937a1.767,1.767,0,0,0-.925-.868q-.4-.166-.805-.344,1.026,1.307,1.836,2.508l.008-.028A1.8,1.8,0,0,0-382.39,650.272Z",
    transform: "translate(439.012 -561.065)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_453",
    "data-name": "Grupo 453",
    transform: "translate(57.951 28.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2284",
    "data-name": "Caminho 2284",
    d: "M-296.093,659.454l-2.519.381c-.638.1-1.277.181-1.912.255a57.388,57.388,0,0,1-22.083-1.7,57.866,57.866,0,0,1-41.739-47.07l-1.594-10.579-.6-3.975,2.863-.431.085.574,2.106,13.98a54.939,54.939,0,0,0,62.441,46.081l1.981-.3.538-.081Z",
    transform: "translate(366.538 -596.337)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2285",
    "data-name": "Caminho 2285",
    d: "M-368.169,928.563-486.7,895.619h0l118.532,32.943Z",
    transform: "translate(486.701 -722.779)",
    fill: "none",
    stroke: "#161615",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2286",
    "data-name": "Caminho 2286",
    d: "M-268.629,570.411-387.16,537.468h0l118.532,32.943Z",
    transform: "translate(435.166 -537.354)",
    fill: "none",
    stroke: "#161615",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_454",
    "data-name": "Grupo 454",
    transform: "translate(4.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2287",
    "data-name": "Caminho 2287",
    d: "M-429.164,537.232l-48.781,175.516,6.477,1.8,48.781-175.516Zm-44.317,173.754-.9-.25,47.231-169.94.9.25Z",
    transform: "translate(477.945 -537.232)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_455",
    "data-name": "Grupo 455",
    transform: "translate(107.419 28.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2288",
    "data-name": "Caminho 2288",
    d: "M-215.185,596.7l-48.781,175.516,6.478,1.8L-208.707,598.5ZM-259.5,770.457l-.9-.25,47.231-169.94.9.25Z",
    transform: "translate(263.966 -596.703)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_456",
    "data-name": "Grupo 456",
    transform: "translate(69.716 145.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2289",
    "data-name": "Caminho 2289",
    d: "M-308.469,873.694-310.221,876l-.408-.314c-1.788-1.383-9.12-7.115-16.16-13.682-8.412-7.844-13.317-13.912-14.842-18.386a7.344,7.344,0,0,1-.372-4.048l1.41.332,1.406.326c-1.457,6.252,17.921,23.731,30.581,33.362C-308.559,873.623-308.515,873.661-308.469,873.694Z",
    transform: "translate(342.145 -839.571)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(26.309 145.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2290",
    "data-name": "Caminho 2290",
    d: "M-385.817,840.22a7.353,7.353,0,0,1-2.412,3.274c-3.61,3.047-10.943,5.713-22.2,8.092-9.418,1.992-18.656,3.119-20.9,3.381l-.512.058-.311-2.88c.056,0,.114-.013.17-.018,15.809-1.718,41.433-6.69,43.411-12.8l1.377.448Z",
    transform: "translate(432.149 -839.331)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_38",
    "data-name": "Linha 38",
    x2: 0.005,
    y2: 0.001,
    transform: "translate(122.553 97.086)",
    fill: "none",
    stroke: "#161615",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2291",
    "data-name": "Caminho 2291",
    d: "M-247.306,740.677",
    transform: "translate(362.76 -642.561)",
    fill: "none",
    stroke: "#161615",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_458",
    "data-name": "Grupo 458",
    transform: "translate(86.735 102.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2292",
    "data-name": "Caminho 2292",
    d: "M-300.009,752a50.838,50.838,0,0,0-5.065,1.906c-.222-.1-.451-.2-.676-.288a1.381,1.381,0,0,1-.137-.063.441.441,0,0,1-.074-.04.35.35,0,0,1-.06-.037.149.149,0,0,0-.039-.021c-.029-.023-.055-.04-.083-.063a.709.709,0,0,1-.115-.092l-.048-.043a1.007,1.007,0,0,1-.1-.108,1.407,1.407,0,0,1-.19-.253.014.014,0,0,0-.008-.007.247.247,0,0,0-.019-.041,1.029,1.029,0,0,1-.064-.128,1.443,1.443,0,0,1-.1-.258,1.146,1.146,0,0,1-.037-.155,1.546,1.546,0,0,1-.033-.314c0-.055,0-.11.005-.164s.01-.108.021-.164.019-.105.035-.161c.874-.408,1.83-.8,2.861-1.2h0c1.159.152,2.32.259,3.476.315Z",
    transform: "translate(306.855 -750.305)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2293",
    "data-name": "Caminho 2293",
    d: "M-377.561,698.248",
    transform: "translate(430.196 -620.594)",
    fill: "none",
    stroke: "#161615",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_459",
    "data-name": "Grupo 459",
    transform: "translate(73.661 97.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2294",
    "data-name": "Caminho 2294",
    d: "M-315.511,753.294c-.289.124-.566.253-.837.383a12.98,12.98,0,0,0-4.546,3.156,1.774,1.774,0,0,1-1.931.59l-.056-.016a1.777,1.777,0,0,1-1.349-1.5,12.879,12.879,0,0,0-2.271-5.051c-.161-.25-.335-.5-.513-.763.246.033.487.066.732.1a2.035,2.035,0,0,0,.305.019.553.553,0,0,0,.112-.009.267.267,0,0,0,.072-.005.952.952,0,0,0,.157-.026l.107-.026c.043-.013.082-.027.122-.041s.09-.035.136-.057a.945.945,0,0,0,.128-.065.968.968,0,0,0,.121-.076,1.032,1.032,0,0,0,.118-.082,1.68,1.68,0,0,0,.389-.427c.027-.043.054-.085.076-.129.011-.022.022-.044.035-.07a.29.29,0,0,0,.032-.061l.2-.009a19.772,19.772,0,0,1,2.354,4.549,19.955,19.955,0,0,1,4.366-2.686c.1.062.081.052.172.118,0,.014,0,.025-.005.039s0,.049,0,.069,0,.029-.005.039l0,.119a0,0,0,0,1,0,.006c0,.009,0,.015,0,.025,0,.05.008.1.009.148a1.649,1.649,0,0,0,.065.305,1.58,1.58,0,0,0,.079.206,1.739,1.739,0,0,0,.079.166l0,.005.027.048a1.4,1.4,0,0,0,.231.3.5.5,0,0,1,.059.056l.048.043c.044.04.089.072.134.106s.067.048.1.07a.352.352,0,0,0,.06.037.445.445,0,0,0,.074.041,1.4,1.4,0,0,0,.137.063C-315.962,753.1-315.733,753.193-315.511,753.294Z",
    transform: "translate(330.366 -744.903)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2295",
    "data-name": "Caminho 2295",
    d: "M-327.9,744.4a1.422,1.422,0,0,1-.1.266c-.013.027-.024.049-.035.07-.022.044-.049.086-.076.129a1.682,1.682,0,0,1-.389.427,1.032,1.032,0,0,1-.118.082.96.96,0,0,1-.121.076.945.945,0,0,1-.128.065c-.046.022-.091.039-.136.057s-.078.028-.122.041l-.107.026a1.257,1.257,0,0,1-.157.026.266.266,0,0,1-.072.005.557.557,0,0,1-.112.009,2.035,2.035,0,0,1-.305-.019c-.245-.038-.486-.07-.732-.1a52.1,52.1,0,0,0-3.352-4.24l1.089-.949c1.019.549,2.069,1.056,3.141,1.523Q-328.708,743.2-327.9,744.4Z",
    transform: "translate(333.964 -740.365)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 176.382,
    height: 0.936,
    transform: "translate(7.786 173.503) rotate(-74.468)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_588",
    "data-name": "Ret\\xE2ngulo 588",
    width: 176.382,
    height: 0.936,
    transform: "translate(110.982 202.184) rotate(-74.468)",
    fill: "#dbdbdb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmpulheta);
export default __webpack_public_path__ + "static/media/ampulheta.42afacfec130f882b38a0b207238234c.svg";
export { ForwardRef as ReactComponent };